import { useParams } from 'react-router-dom';

export function useEpisodeId() {
  const { episodeId } = useParams<{ episodeId?: string }>();

  return episodeId;
}
